module.exports = __webpack_public_path__ + "static/img/redeem-bg.ba361a32.png";